import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/api';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track public pages, not admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Track the page view
    const track = async () => {
      try {
        await trackPageView(
          location.pathname,
          document.referrer || null,
          navigator.userAgent
        );
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Analytics tracking failed:', error);
      }
    };

    track();
  }, [location.pathname]);
};

export default usePageTracking;
